<template>
    <sections>
        <section-signup
            heading="Signup"
            :content="'<p>Create an account on the ' + $config.public.siteName + ' website.</p>'"
        ></section-signup>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Signup | ' + $config.public.siteName,
    description: 'Create an account on the ' + $config.public.siteName + ' website.',
    index: true,
});
</script>
